import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import {
  type GuestsState,
  SelectGuestsForm,
  kyrgyzstanSearchStore,
} from 'entities/kyrgyzstan'

import { HeaderGoBack } from 'shared/ui/header-go-back'

const KyrgyzstanSelectGuestsPage = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { setGuests, guests } = kyrgyzstanSearchStore

  const handleGoBack = () => {
    navigate(-1)
  }

  const handleSubmit = (guestsState: GuestsState) => {
    setGuests(guestsState)
    navigate(-1)
  }

  return (
    <div className={clsx('container')}>
      <HeaderGoBack
        buttonWhite
        title={t('kyrgyzstan_block.select_guests.title')}
        variant="grey"
        onGoBack={handleGoBack}
      />

      <SelectGuestsForm
        initialState={guests}
        onSubmit={handleSubmit}
        showSubmitButton
      />
    </div>
  )
})

export default KyrgyzstanSelectGuestsPage
